import React from 'react';
import { Link as LinkOriginal } from 'gatsby';
import { isAbsoluteUrl, isOwnDomain } from './utils';

function Link({ className, href = '', children, onClick, state, target, ...other }) {
  if (isAbsoluteUrl(href) && !isOwnDomain(href)) {
    return (
      <a
        className={className}
        onClick={onClick}
        href={href}
        target="_blank"
        rel="noreferrer noopener nofollow"
        {...other}
      >
        {children}
      </a>
    );
  }

  if (isAbsoluteUrl(href) || target) {
    return (
      <a className={className} onClick={onClick} href={href} target={target} {...other}>
        {children}
      </a>
    );
  }

  return (
    <LinkOriginal onClick={onClick} className={className} to={href} state={state} {...other}>
      {children}
    </LinkOriginal>
  );
}

export default React.memo(Link);
